import { render, staticRenderFns } from "./AccesoParaTesteosList.vue?vue&type=template&id=d0117f2e&scoped=true"
import script from "./AccesoParaTesteosList.vue?vue&type=script&lang=js"
export * from "./AccesoParaTesteosList.vue?vue&type=script&lang=js"
import style0 from "./AccesoParaTesteosList.vue?vue&type=style&index=0&id=d0117f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0117f2e",
  null
  
)

export default component.exports